import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../Components/AuthContext';
import closeIcon from '../Images/close.png';
import eyeIcon from '../Images/view.png';
import eyeOffIcon from '../Images/hide.png';

const LoginModal = ({ isModalVisible, setIsModalVisible, onLoginSuccess }) => {
  const { setToken, setUserData } = useContext(AuthContext);
  const [showLogin, setShowLogin] = useState(true);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordShownLogin, setPasswordShownLogin] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordShownRegister, setPasswordShownRegister] = useState(false);
  const [confirmpasswordShownRegister, setConfirmpasswordShownRegister] = useState(false);

  const [errorMessage, setErrorMessage] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [registrationToken, setRegistrationToken] = useState("");

   // --- forgot-password state ---
   const [showForgotFlow, setShowForgotFlow] = useState(false);
   const [forgotStep, setForgotStep] = useState(1); // 1=email,2=code,3=reset
   const [forgotToken, setForgotToken] = useState('');
   const [forgotEmail, setForgotEmail] = useState('');
   const [forgotEmailError, setForgotEmailError] = useState('');
   const [forgotCode, setForgotCode] = useState(new Array(6).fill(""));
   const [forgotCodeError, setForgotCodeError] = useState('');
   const [newPassword, setNewPassword] = useState('');
   const [newPasswordError, setNewPasswordError] = useState('');
   const [newPasswordShown, setNewPasswordShown] = useState(false);
   const [confirmNewPassword, setConfirmNewPassword] = useState('');
   const [confirmNewPasswordError, setConfirmNewPasswordError] = useState('');
   const [confirmNewPasswordShown, setConfirmNewPasswordShown] = useState(false);
   const [registrationEmail,   setRegistrationEmail]   = useState("");
   const [resendTimer, setResendTimer] = useState(30);
   const [canResend, setCanResend]   = useState(false);
   const [resendTrigger, setResendTrigger] = useState(0);


  

  
// generic error
useEffect(() => {
  if (!errorMessage) return;
  const id = setTimeout(() => setErrorMessage(''), 5000);
  return () => clearTimeout(id);
}, [errorMessage]);

// login / register form errors
useEffect(() => {
  if (!emailError) return;
  const id = setTimeout(() => setEmailError(''), 5000);
  return () => clearTimeout(id);
}, [emailError]);

useEffect(() => {
  if (!passwordError) return;
  const id = setTimeout(() => setPasswordError(''), 5000);
  return () => clearTimeout(id);
}, [passwordError]);

useEffect(() => {
  if (!firstNameError) return;
  const id = setTimeout(() => setFirstNameError(''), 5000);
  return () => clearTimeout(id);
}, [firstNameError]);

useEffect(() => {
  if (!lastNameError) return;
  const id = setTimeout(() => setLastNameError(''), 5000);
  return () => clearTimeout(id);
}, [lastNameError]);

useEffect(() => {
  if (!confirmPasswordError) return;
  const id = setTimeout(() => setConfirmPasswordError(''), 5000);
  return () => clearTimeout(id);
}, [confirmPasswordError]);

// forgot-password flow errors
useEffect(() => {
  if (!forgotEmailError) return;
  const id = setTimeout(() => setForgotEmailError(''), 5000);
  return () => clearTimeout(id);
}, [forgotEmailError]);

useEffect(() => {
  if (!forgotCodeError) return;
  const id = setTimeout(() => setForgotCodeError(''), 5000);
  return () => clearTimeout(id);
}, [forgotCodeError]);

useEffect(() => {
  if (!newPasswordError) return;
  const id = setTimeout(() => setNewPasswordError(''), 5000);
  return () => clearTimeout(id);
}, [newPasswordError]);

useEffect(() => {
  if (!confirmNewPasswordError) return;
  const id = setTimeout(() => setConfirmNewPasswordError(''), 5000);
  return () => clearTimeout(id);
}, [confirmNewPasswordError]);


   
   useEffect(() => {
    let intervalId;
    if (showOtpPopup) {
      setCanResend(false);
      setResendTimer(30);
      intervalId = setInterval(() => {
        setResendTimer(prev => {
          if (prev <= 1) {
            clearInterval(intervalId);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [showOtpPopup, resendTrigger]);
  

   const resetAllErrors = () => {
    setErrorMessage('');
    setEmailError('');
    setPasswordError('');
    setFirstNameError('');
    setLastNameError('');
    setConfirmPasswordError('');
    setForgotEmailError('');
    setForgotCodeError('');
    setNewPasswordError('');
    setConfirmNewPasswordError('');
  };

  // Handle OTP input
  const handleOtpChange = (element, index) => {
    const otpValues = [...otp];
    otpValues[index] = element.value;
    setOtp(otpValues);

    if (element.nextSibling && element.value) {
      element.nextSibling.focus();
    }
  };

  // 1) Add this above your JSX:
const handleOtpPaste = (e, startIndex) => {
  e.preventDefault();
  // grab the pasted text
  const paste = e.clipboardData.getData('text').trim();
  if (!paste) return;

  // turn it into an array and limit to remaining slots
  const chars = paste.split('').slice(0, otp.length - startIndex);
  const newOtp = [...otp];

  chars.forEach((ch, i) => {
    if (/^\d$/.test(ch)) {
      newOtp[startIndex + i] = ch;
    }
  });

  setOtp(newOtp);

  // optionally move focus to last filled box
  const finalIndex = Math.min(startIndex + chars.length - 1, otp.length - 1);
  const inputs = Array.from(e.target.form.querySelectorAll('input'));
  inputs[finalIndex]?.focus();
};

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setEmailError('');
    setPasswordError('');

    if (!email) {
      setEmailError('Email is required.');
      return;
    }
    if (!password) {
      setPasswordError('Password is required.');
      return;
    }

    const response = await fetch('https://backend.printtrio.co.uk/api/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });

    const data = await response.json();
    if (data.success) {
      const { token, user } = data.data;

      setToken(token);
      setUserData({
        firstName: user.first_name,
        lastName: user.last_name,
        image: user.image,
        role:      user.role,
      });
      localStorage.setItem('token', token);
      localStorage.setItem('firstName', user.first_name);
      localStorage.setItem('lastName', user.last_name);
      localStorage.setItem('image', user.image);
      localStorage.setItem('role',      user.role);
      document.cookie = "isLoggedIn=true; path=/";
      setIsModalVisible(false);
      onLoginSuccess();
    } else {
      setErrorMessage('Invalid email or password.');
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
  
    // Clear existing error messages
    setErrorMessage('');
    setEmailError('');
    setPasswordError('');
    setFirstNameError('');
    setLastNameError('');
    setConfirmPasswordError('');
  
    // Validate inputs
    let hasError = false;
    if (!firstName) {
      setFirstNameError('First name is required.');
      hasError = true;
    }
    if (!lastName) {
      setLastNameError('Last name is required.');
      hasError = true;
    }
    if (!email) {
      setEmailError('Email is required.');
      hasError = true;
    }
    if (!password) {
      setPasswordError('Password is required.');
      hasError = true;
    } else {
      // const uppercaseRegex      = /[A-Z]/;
      // const lowercaseRegex      = /[a-z]/;
      // const digitRegex          = /\d/;
      // const specialCharRegex    = /[@$!%*?&]/;
  
      // if (password.length < 8) {
      //   setPasswordError('Password must be at least 8 characters long.');
      //   hasError = true;
      // } else if (!uppercaseRegex.test(password)) {
      //   setPasswordError('Password must contain at least one uppercase letter.');
      //   hasError = true;
      // } else if (!lowercaseRegex.test(password)) {
      //   setPasswordError('Password must contain at least one lowercase letter.');
      //   hasError = true;
      // } else if (!digitRegex.test(password)) {
      //   setPasswordError('Password must contain at least one digit.');
      //   hasError = true;
      // } else if (!specialCharRegex.test(password)) {
      //   setPasswordError('Password must contain at least one special character (@$!%*?&).');
      //   hasError = true;
      // }
    }
    if (password !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match.');
      hasError = true;
    }
    if (hasError) return;
    setRegistrationEmail(email);
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/auth/register', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Accept':       'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          first_name:            firstName,
          last_name:             lastName,
          email,
          password,
          password_confirmation: confirmPassword,
        }),
      });
  
      // Read raw text and log it for debugging
      const rawText = await response.text();
      console.log('Registration response status:', response.status);
      console.log('Registration raw response:', rawText);
  
      // Try to parse JSON
      let data;
      try {
        data = JSON.parse(rawText);
      } catch (jsonErr) {
        console.error('Failed to parse registration JSON:', jsonErr);
        setErrorMessage('Server returned invalid data.');
        return;
      }
      console.log('Registration JSON payload:', data);
  
      // Handle success vs. failure
      if (response.ok && data.success && data.data?.token) {
        console.log('Registration Token:', data.data.token);
        setRegistrationToken(data.data.token); // Save token for OTP
        setShowOtpPopup(true);                 // Show OTP popup
      } else {
        // Show server-provided message or a generic fallback
        setErrorMessage(data.message || 'Registration failed.');
      }
    } catch (networkError) {
      console.error('Network or CORS error during registration:', networkError);
      setErrorMessage('Network error—could not reach the server.');
    }
  };
  
  

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join(""); // Combine OTP array into a single string

    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/auth/verify/check-code', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: registrationToken,
          code: enteredOtp,
        }),
      });
      const data = await response.json();
      if (data.success) {
        const { token, user } = data.data;

        setToken(token);
        setUserData({
          firstName: user.first_name,
          lastName: user.last_name,
          image: user.image,
          role:      user.role,   
        });

        localStorage.setItem('token', token);
        localStorage.setItem('firstName', user.first_name);
        localStorage.setItem('lastName', user.last_name);
        localStorage.setItem('image', user.image);
        localStorage.setItem('role',      user.role);

        setShowOtpPopup(false); // Close OTP popup
        setIsModalVisible(false); // Close modal
        onLoginSuccess(); // Trigger login success callback
      } else {
        setErrorMessage('Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error('OTP Verification Error:', error);
      setErrorMessage('An error occurred while verifying OTP.');
    }
  };
  
  const handleResendOtp = async () => {
    if (!registrationToken) {
      setErrorMessage('Registration token is missing. Please register again.');
      return;
    }
  
    try {
      const response = await fetch('https://backend.printtrio.co.uk/api/auth/verify/rest-code', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json', // Add Content-Type explicitly
        },
             body: JSON.stringify({
                 token: registrationToken,
                 email: registrationEmail,      // include the email so the mailer has a "To" address
               }),
      });
  
      const data = await response.json();
  
      if (response.ok && data.success) {
        setErrorMessage('A new OTP has been sent to your email.'); // Success message
      } else {
        setErrorMessage(data.message);
      }
    } catch (error) {
      console.error('Error resending OTP:', error);
      setErrorMessage('An error occurred while resending the OTP. Please try again.');
    }
  };
  
  
  const handleStartForgot = () => {
    resetAllErrors();
    setShowForgotFlow(true);
    setForgotStep(1);
    // clear
    setForgotEmail('');
    setForgotCode(new Array(6).fill(''));
    setNewPassword('');
    setConfirmNewPassword('');
  };

  const handleForgotEmailSubmit = async (e) => {
    e.preventDefault();
    resetAllErrors();
  
    // Validate input
    if (!forgotEmail) {
      setForgotEmailError('Email is required.');
      return;
    }
  
    try {
      const res = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail }),
      });
  
      // Check HTTP status
      if (!res.ok) {
        // e.g. 404 Not Found or 422 Unprocessable Entity
        const text = await res.text();
        console.error('Forgot-password HTTP error:', res.status, text);
        setErrorMessage('Could not send reset code. Please try again later.');
        return;
      }
  
      const data = await res.json();
      console.log('Forgot-password response:', data);
  
      if (data.success && data.data?.token) {
        setForgotToken(data.data.token);
        setForgotStep(2);
      } else {
        // API returned success: false
        const msg = data.message || 'Email address not recognized.';
        setErrorMessage(msg);
      }
  
    } catch (err) {
      console.error('Network error during forgot-password:', err);
      setErrorMessage('Email address not recognized.');
    }
  };
  

  const handleForgotCodeSubmit = async e => {
    e.preventDefault();
    resetAllErrors();
    const code = forgotCode.join('');
    if (code.length<6) return setForgotCodeError('Enter full 6 digits.');
    const res = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password/check-code',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ token:forgotToken, code })
    });
    const data = await res.json();
    if (data.success && data.data==='success') {
      setForgotStep(3);
    } else {
      setErrorMessage('Wrong code.');
    }
  };

  const handleForgotResetSubmit = async e => {
    e.preventDefault();
    resetAllErrors();
    if (!newPassword) return setNewPasswordError('Password is required.');
    if (newPassword !== confirmNewPassword) {
      return setConfirmNewPasswordError('Must match new password.');
    }
    const res = await fetch('https://backend.printtrio.co.uk/api/auth/forget-password/update',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({
        token: forgotToken,
        password: newPassword,
        password_confirmation: confirmNewPassword
      })
    });
    const data = await res.json();
    if (data.success) {
      // back to login
      setShowForgotFlow(false);
      setShowLogin(true);
      setErrorMessage('Password updated! Please sign in.');
    } else {
      setErrorMessage(data.message||'Reset failed.');
    }
  };

  // Place this somewhere up with your other handler functions:
const handleForgotCodeChange = (element, index) => {
  const codeValues = [...forgotCode];
  codeValues[index] = element.value;
  setForgotCode(codeValues);

  // auto-advance focus
  if (element.nextSibling && element.value) {
    element.nextSibling.focus();
  }
};

  const togglePasswordVisibility = () => setPasswordShownLogin(!passwordShownLogin);
  const toggleRegisterPasswordVisibility = () => setPasswordShownRegister(!passwordShownRegister);
  const toggleConfirmPasswordVisibility = () => setConfirmpasswordShownRegister(!confirmpasswordShownRegister);

  const toggleModalContent = () => setShowLogin(!showLogin);

  return isModalVisible ? (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto w-full z-50 ">
        <div className="max-w-screen-2xl mx-auto relative">
      <div className="relative top-10 mx-auto p-5 border w-11/12 sm:w-1/3 shadow-lg rounded-xl bg-white ">
        <div className="absolute top-1 right-1 pt-4 pr-4">
          <button onClick={() => setIsModalVisible(false)} className="text-gray-600 hover:text-gray-900">
            <img src={closeIcon} alt="Close" className="h-7 w-7" />
          </button>
        </div>

        {!showOtpPopup ? (
  // ───── FORGOT‐PASSWORD FLOW ─────
  showForgotFlow ? (
    <div className="mt-3 text-start px-7">
      {forgotStep === 1 && (
        <form onSubmit={handleForgotEmailSubmit}>
          <h1 className="text-xl font-bold">Forgot Password</h1>
          <label className="mt-4 block">Enter your email</label>
          <input
            type="email"
            className="mt-2 p-2 border rounded-xl w-full"
            value={forgotEmail}
            onChange={(e) => setForgotEmail(e.target.value)}
          />
          {forgotEmailError && (
            <p className="text-red-500">{forgotEmailError}</p>
          )}
          <button
            type="submit"
            className="mt-4 px-4 py-2 bg-[#EC008C] text-white rounded-full w-full"
          >
            Send Code
          </button>
        </form>
      )}
      {forgotStep === 2 && (
        <form onSubmit={handleForgotCodeSubmit}>
          <h1 className="text-xl font-bold">Enter Verification Code</h1>
          <div className="flex gap-2 mt-4 justify-center">
            {forgotCode.map((v, i) => (
              <input
                key={i}
                maxLength="1"
                className="w-10 h-10 text-center border rounded"
                value={v}
                onChange={(e) => handleForgotCodeChange(e.target, i)}
              />
            ))}
          </div>
          {forgotCodeError && (
            <p className="text-red-500">{forgotCodeError}</p>
          )}
          <button
            type="submit"
            className="mt-4 px-4 py-2 bg-[#EC008C] text-white rounded-full w-full"
          >
            Verify Code
          </button>
        </form>
      )}
      {forgotStep === 3 && (
        <form onSubmit={handleForgotResetSubmit}>
          <h1 className="text-xl font-bold">Reset Password</h1>
          <label className="mt-4 block">New Password</label>
          <div className="relative">
            <input
              type={newPasswordShown ? "text" : "password"}
              className="mt-2 p-2 border rounded-xl w-full"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3"
              onClick={() => setNewPasswordShown(!newPasswordShown)}
            >
              <img
                src={newPasswordShown ? eyeOffIcon : eyeIcon}
                alt=""
                className="h-6 w-6 mt-3"
              />
            </button>
          </div>
          {newPasswordError && (
            <p className="text-red-500">{newPasswordError}</p>
          )}
          <label className="mt-4 block">Confirm New Password</label>
          <div className="relative">
            <input
              type={confirmNewPasswordShown ? "text" : "password"}
              className="mt-2 p-2 border rounded-xl w-full"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3"
              onClick={() => setConfirmNewPasswordShown(!confirmNewPasswordShown)}
            >
              <img
                src={confirmNewPasswordShown ? eyeOffIcon : eyeIcon}
                alt=""
                className="h-6 w-6 mt-3"
              />
            </button>
          </div>
          {confirmNewPasswordError && (
            <p className="text-red-500">{confirmNewPasswordError}</p>
          )}
          <button
            type="submit"
            className="mt-4 px-4 py-2 bg-[#EC008C] text-white rounded-full w-full"
          >
            Update Password
          </button>
        </form>
      )}
      {errorMessage && <p className="text-red-500 mt-4">{errorMessage}</p>}
      <button
        onClick={() => {
          resetAllErrors();
          setShowForgotFlow(false);
        }}
        className="mt-4 text-sm text-blue-600 underline"
      >
        Back to Login
      </button>
    </div>
  ) : showLogin ? (
    // ───── LOGIN FORM ─────
    <div className="mt-3 text-start">
      <div className="mt-4 px-7">
        <h1 className="text-xl leading-6 font-bold text-gray-900">Login</h1>
      </div>
      <form className="mt-2 px-7 py-3" onSubmit={handleLogin}>
        <label>Email</label>
        <input
          type="email"
          placeholder="username@gmail.com"
          className="mt-2 mb-2 p-2 border rounded-xl w-full"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailError && (
          <p className="text-red-500 text-sm">{emailError}</p>
        )}
        <label>Password</label>
        <div className="mt-2 relative">
          <input
            type={passwordShownLogin ? "text" : "password"}
            placeholder="Password"
            className="mt-2 p-2 border rounded-xl w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
          >
            <img
              src={passwordShownLogin ? eyeOffIcon : eyeIcon}
              alt="Toggle Password Visibility"
              className="h-6 w-6 mt-3 text-gray-700"
            />
          </button>
        </div>
        {passwordError && (
          <p className="text-red-500 text-sm">{passwordError}</p>
        )}
        {errorMessage && (
          <p className="text-red-500 text-sm">{errorMessage}</p>
        )}
        <p
          className="text-sm mt-2 text-right text-blue-600 cursor-pointer"
          onClick={() => setShowForgotFlow(true)}
        >
          Forgot password?
        </p>
        <div className="items-center py-3">
          <button
            type="submit"
            className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm"
          >
            Sign in
          </button>
        </div>
      </form>
      <div className="flex items-center justify-center px-4 mb-5 gap-2">
        <span className="text-sm text-[#EC008C]">Don’t have an account yet?</span>
        <button
          className="font-medium text-gray-500 hover:text-[#EC008C]"
          onClick={toggleModalContent}
        >
          Register for free
        </button>
      </div>
    </div>
  ) : (
    // ───── REGISTER FORM ─────
    <div className="mt-3 text-start">
      <div className="px-7 py-3">
        <h1 className="text-xl leading-6 font-bold text-gray-900">Register</h1>
      </div>
      <form className="mt-2 px-7 py-2" onSubmit={handleRegister}>
        <label className="text-sm">First Name</label>
        <input
          type="text"
          placeholder="First Name"
          className="mt-2 mb-2 p-2 border rounded-xl w-full"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        {firstNameError && (
          <p className="text-red-500 text-sm">{firstNameError}</p>
        )}
        <label className="text-sm">Last Name</label>
        <input
          type="text"
          placeholder="Last Name"
          className="mt-2 mb-2 p-2 border rounded-xl w-full"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        {lastNameError && (
          <p className="text-red-500 text-sm">{lastNameError}</p>
        )}
        <label className="text-sm">Email</label>
        <input
          type="email"
          placeholder="username@gmail.com"
          className="mt-2 mb-2 p-2 border rounded-xl w-full"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailError && (
          <p className="text-red-500 text-sm">{emailError}</p>
        )}
        <label className="text-sm">Password</label>
        <div className="mb-2 relative">
          <input
            type={passwordShownRegister ? "text" : "password"}
            placeholder="Password"
            className="mt-2 p-2 border rounded-xl w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={toggleRegisterPasswordVisibility}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
          >
            <img
              src={passwordShownRegister ? eyeOffIcon : eyeIcon}
              alt="Toggle Password Visibility"
              className="h-6 w-6 mt-3 text-gray-700"
            />
          </button>
        </div>
        {passwordError && (
          <p className="text-red-500 text-sm">{passwordError}</p>
        )}
        <label className="text-sm">Confirm Password</label>
        <div className="mb-2 relative">
          <input
            type={confirmpasswordShownRegister ? "text" : "password"}
            placeholder="Confirm Password"
            className="mt-2 p-2 border rounded-xl w-full"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={toggleConfirmPasswordVisibility}
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
          >
            <img
              src={confirmpasswordShownRegister ? eyeOffIcon : eyeIcon}
              alt="Toggle Confirm Password Visibility"
              className="h-6 w-6 mt-3 text-gray-700"
            />
          </button>
        </div>
        {confirmPasswordError && (
          <p className="text-red-500 text-sm">{confirmPasswordError}</p>
        )}
        {errorMessage && (
          <p className="text-red-500 text-sm">{errorMessage}</p>
        )}
        <div className="items-center py-3">
          <button
            type="submit"
            className="px-4 py-2 bg-[#EC008C] text-white text-xl font-semibold rounded-full w-full shadow-sm"
          >
            Register
          </button>
        </div>
      </form>
      <div className="flex items-center justify-center px-4 mb-5 gap-2">
        <span className="text-sm text-[#EC008C]">Already have an account?</span>
        <button
          className="font-medium text-gray-500 hover:text-[#EC008C]"
          onClick={toggleModalContent}
        >
          Sign in
        </button>
      </div>
    </div>
  )
) : (
  // ───── OTP POPUP ─────
  <div>
    <h3 className="text-xl font-bold mb-4 mt-8 ml-14">
      Please Verify Email
    </h3>
    <p className="text-sm mb-4 mt-2 w-40 md:w-80 ml-14">
      We’ve sent an email with instructions. Enter the 6-digit code below.
    </p>
    <form onSubmit={handleOtpSubmit}>
      <div className="flex justify-center gap-2 mb-4 mt-10">
        {otp.map((value, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            value={value}
            onChange={(e) => handleOtpChange(e.target, index)}
            onPaste={(e) => handleOtpPaste(e, index)}
            className="w-10 h-10 text-center border rounded"
          />
        ))}
      </div>
      {errorMessage && (
        <p className="text-red-500 text-sm">{errorMessage}</p>
      )}
      <button
        type="submit"
        className="w-full bg-[#EC008C] text-white py-2 rounded mt-10 mb-4"
      >
        Verify OTP
      </button>
{/* replace the existing "I didn't receive the code" <span> block with this */}
<p className="text-sm text-center mb-4 mt-2">
{canResend ? (
  <span
    className="text-[#EC008C] cursor-pointer"
    onClick={() => {
      handleResendOtp();
      setResendTrigger(t => t + 1);
    }}
  >
    Resend It Again
  </span>
) : (
  <span className="text-gray-500">
    Resend in {resendTimer}s
  </span>
)}

</p>

      <p className="text-sm text-center">
    <button
      type="button"
      className="text-gray-600 hover:text-gray-900 underline"
      onClick={() => {
        resetAllErrors();
        setShowOtpPopup(false);
        setShowLogin(true);
      }}
    >
      Back to Login
    </button>
  </p>
    </form>
  </div>
)}



      </div>
      </div>
    </div>
  ) : null;
};

export default LoginModal;

